import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { trpc, trpcClient } from './api/trpc';
import App from './App';
import GTMProvider from './components/gtmProvider/GTMProvider';
import { PostHogProvider } from 'posthog-js/react'
import "./index.css";
import './instrument';
import { Toaster } from './components/ui/sonner';
import { initEmbedMode, isEmbedded } from './lib/embed';
import type { PostHogConfig } from 'posthog-js';

dayjs.locale('de');

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

dayjs.tz.setDefault('Europe/Berlin');

// Create a client for react-query
const queryClient = new QueryClient();

const posthogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;
const posthogPublicKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const options: Partial<PostHogConfig> = {
    api_host: posthogHost,
    loaded: (posthogInstance) => {
        if (isEmbedded()) {
            posthogInstance.register({ embedded: true });
        }
    },
}

initEmbedMode();

const root = createRoot(document.getElementById('root')!);
root.render(
    // <React.StrictMode>
        <PostHogProvider
            apiKey={posthogPublicKey}
            options={options}
        >
            <trpc.Provider client={trpcClient} queryClient={queryClient}>
                <QueryClientProvider client={queryClient}>
                    <BrowserRouter>
                        <GTMProvider>
                            <App />
                            <Toaster />
                        </GTMProvider>
                    </BrowserRouter>
                </QueryClientProvider>
            </trpc.Provider>
        </PostHogProvider>
    // </React.StrictMode>
);